module.exports = __webpack_public_path__ + "static/media/time-to-green.bf8bfcc2.png";